import {
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmButton,
   ModalWidth,
   ShowModalEventInterceptor,
   ValidateFormEventInterceptor,
} from '@dreryk/react-components';

import {
   MedicalDocumentationPasswordDetailsShowModalInterceptor,
   MedicalDocumentationShareForm,
} from '~libs.desktop.shared.medical-documentation';

import { MedicalDocumentationCreateFormController } from '../../MedicalDocumentationCreateForm.types';
import { medicalDocumentationCreateTranslationKeys } from '../../../../translations';

import { MedicalDocumentationSendActionEventInterceptor } from './MedicalDocumentationSendActionEventInterceptor';

type MedicalDocumentationSendAndShareShowModalEventInterceptorProps = Pick<
   MedicalDocumentationCreateFormController,
   'handleSubmit'
> &
   Readonly<{
      children: JSX.Element;
      patientId: number;
   }>;

export const MedicalDocumentationSendAndShareShowModalEventInterceptor = (
   props: MedicalDocumentationSendAndShareShowModalEventInterceptorProps
): JSX.Element => {
   const { handleSubmit: handleMedicalDocumentationGenerateSubmit } = props;
   return (
      <ShowModalEventInterceptor
         testId={'sharePatientDocumentation'}
         title={medicalDocumentationCreateTranslationKeys.shareRecordsWithPatient}
         content={({ resolve, reject }) => (
            <MedicalDocumentationShareForm patientId={props.patientId}>
               {({ trigger, handleSubmit: handleMedicalDocumentationShareSubmit }) => {
                  return (
                     <>
                        <ValidateFormEventInterceptor trigger={trigger}>
                           <MedicalDocumentationSendActionEventInterceptor
                              patientId={props.patientId}
                              handleMedicalDocumentationGenerateSubmit={handleMedicalDocumentationGenerateSubmit}
                              handleMedicalDocumentationShareSubmit={handleMedicalDocumentationShareSubmit}
                           >
                              {({ filePassword }) => (
                                 <MedicalDocumentationPasswordDetailsShowModalInterceptor
                                    filePassword={filePassword}
                                    title={medicalDocumentationCreateTranslationKeys.createdAndSentPatientRecords}
                                    successMessage={
                                       medicalDocumentationCreateTranslationKeys.sentDocumentationToPatientAndSmsMessageWithPassword
                                    }
                                 >
                                    <ModalConfirmButton
                                       label={medicalDocumentationCreateTranslationKeys.send}
                                       onClick={resolve}
                                    />
                                 </MedicalDocumentationPasswordDetailsShowModalInterceptor>
                              )}
                           </MedicalDocumentationSendActionEventInterceptor>
                        </ValidateFormEventInterceptor>

                        <ModalCancelButton label={medicalDocumentationCreateTranslationKeys.back} onClick={reject} />
                        <ModalCloseButton onClick={reject} />
                     </>
                  );
               }}
            </MedicalDocumentationShareForm>
         )}
         modalWidth={ModalWidth.NORMAL}
         shouldShowModal
         footerItemsHidden
      >
         {props.children}
      </ShowModalEventInterceptor>
   );
};
